// Mock data for Sunday Mirror site

export const BRAND = {
  name: 'Sunday Mirror',
  tagline: 'Your Wedding. Anywhere in the World.',
  promise: 'One Team. Everything Wedding.',
  phone: '+91 9567 655 569',
  email: 'info@sundaymirror.in',
  address: '63B-Manjima, Eastern Villas, Padamughal, Kakkanad, Kochi, 682037',
};

export const NAV = [
  { label: 'Home', path: '/' },
  { label: 'Destinations', path: '/destinations' },
  { label: 'Plan My Wedding', path: '/plan' },
  { label: 'Wedding Services', path: '/services' },
  { label: 'Find Your Team', path: '/team' },
  { label: 'Certified', path: '/certified' },
  { label: 'Real Weddings', path: '/real-weddings' },
  { label: 'Mirror AI', path: '/mirror-ai' },
  { label: 'About', path: '/about' },
  { label: 'Journal', path: '/journal' },
  { label: 'Contact', path: '/contact' },
];

export const HERO_IMAGE = 'https://images.unsplash.com/photo-1756190564669-215843660e93';

export const DESTINATIONS_INDIA = [
  { name: 'Royal Rajasthan', tag: 'Palaces & Heritage', image: 'https://images.unsplash.com/photo-1661924326425-c14a6426d989?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { name: 'Sunny Goa', tag: 'Beaches & Resorts', image: 'https://images.unsplash.com/photo-1658691530647-8b1169ab7352' },
  { name: 'Backwater Kerala', tag: 'Waterways & Houseboats', image: 'https://images.unsplash.com/photo-1704365159747-1f7b8913044f?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { name: 'Mountain Escapes', tag: 'Himalayan Retreats', image: 'https://images.unsplash.com/photo-1591946522651-90fbace43004?crop=entropy&cs=srgb&fm=jpg&q=85' },
];

export const DESTINATIONS_WORLD = [
  { name: 'Santorini', country: 'Greece', image: 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { name: 'Dubai', country: 'UAE', image: 'https://images.unsplash.com/photo-1719410876441-48357b53e6fd' },
  { name: 'Thailand', country: 'Phuket & Krabi', image: 'https://images.unsplash.com/photo-1636665144655-d575eb467faa' },
  { name: 'Bali', country: 'Indonesia', image: 'https://images.unsplash.com/photo-1542897644-e04428948020?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { name: 'Maldives', country: 'Overwater Villas', image: 'https://images.unsplash.com/photo-1698726654908-834d3a5330d8?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { name: 'Italy', country: 'Lake Como & Tuscany', image: 'https://images.unsplash.com/photo-1556630279-0ecfac70eaf2?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { name: 'Sri Lanka', country: 'Galle & Tangalle', image: 'https://images.unsplash.com/photo-1625721838087-c46e51c89558?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { name: 'Mauritius', country: 'Indian Ocean', image: 'https://images.unsplash.com/photo-1551918120-9739cb430c6d?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { name: 'Turkey', country: 'Cappadocia & Bodrum', image: 'https://images.unsplash.com/photo-1678266561093-324802646fb2?crop=entropy&cs=srgb&fm=jpg&q=85' },
];

export const WHY_POINTS = [
  { title: 'One Point of Responsibility', body: 'One Wedding Manager connects your family, venue, suppliers and Sunday Mirror teams.' },
  { title: 'Sunday Mirror Certified', body: 'A structured verification, training and feedback standard built to make service quality predictable across destinations.' },
  { title: 'Local Knowledge. Global Standards.', body: 'Destination teams provide local understanding while our central system maintains consistent service.' },
  { title: 'Transparent Planning', body: 'Know what is booked, pending, approved and being spent — in one place.' },
  { title: 'Backup Matters', body: 'Critical services require contingency thinking. We plan beyond the perfect scenario.' },
  { title: 'Human When It Matters', body: 'Technology keeps everything organised. People make the wedding extraordinary.' },
];

export const SERVICES = [
  { title: 'Destination Planning', items: ['Destination research', 'Venue sourcing', 'Venue visits', 'Negotiations', 'Budget planning'] },
  { title: 'Wedding Planning', items: ['Planning calendar', 'Vendor management', 'Function planning', 'Family coordination', 'Event-day management'] },
  { title: 'Design & Décor', items: ['Creative direction', 'Moodboards', 'Florals', 'Stages', 'Lighting', 'Tablescapes', 'Signage'] },
  { title: 'Guest Hospitality', items: ['RSVP', 'Room allocation', 'Airport coordination', 'Welcome desks', 'Guest assistance', 'Itineraries'] },
  { title: 'Travel & Transport', items: ['Group movement', 'Airport transfers', 'Local transportation', 'VIP vehicles', 'Guest logistics'] },
  { title: 'Photography & Films', items: ['Wedding photography', 'Films', 'Pre-wedding shoots', 'Content creation'] },
  { title: 'Beauty & Styling', items: ['Makeup', 'Hair', 'Styling', 'Draping', 'Grooming'] },
  { title: 'Entertainment', items: ['DJs', 'Bands', 'Artists', 'Hosts', 'Cultural performances', 'Choreography'] },
  { title: 'Food & Experiences', items: ['Menu planning', 'Food experiences', 'Tastings', 'Local experiences', 'After-parties'] },
  { title: 'Invitations & Gifting', items: ['Digital invitations', 'Printed invitations', 'Wedding stationery', 'Welcome hampers', 'Wedding gifts'] },
];

export const RESPONSIBILITY = [
  { num: '01', title: 'Destination & Venue', body: 'Tell us your vision, guest count and budget. We identify destinations and venues that genuinely work.' },
  { num: '02', title: 'Planning & Design', body: 'From schedules and budgets to décor and entertainment, every element comes together under one plan.' },
  { num: '03', title: 'Your Wedding Team', body: 'Choose from Sunday Mirror Certified photographers, designers, entertainers and professionals.' },
  { num: '04', title: 'Guests & Hospitality', body: 'RSVPs, rooms, transfers, welcome desks and guest experiences — managed end to end.' },
  { num: '05', title: 'Wedding Execution', body: 'Behind every beautiful celebration is serious coordination. Our team runs it.' },
];

export const CERTIFIED_LEVELS = [
  { level: 'Sunday Mirror Certified', body: 'Verified, documented and trained to the Sunday Mirror service standard.' },
  { level: 'Sunday Mirror Preferred', body: 'Proven consistency in service, communication and destination delivery.' },
  { level: 'Sunday Mirror Signature', body: 'Exceptional teams trusted for complex, high-expectation destination celebrations.' },
];

export const CERTIFIED_STANDARDS = [
  'Identity verification',
  'Portfolio and experience verification',
  'Reference checking',
  'Service-quality evaluation',
  'Documented pricing, scope and deliverables',
  'Professional-conduct agreement',
  'Destination capability assessment',
  'Training in Sunday Mirror service standards',
];

export const HOW_IT_WORKS = [
  { num: '01', title: 'Tell Us Your Story', body: 'Share your destination ideas, guest count, dates, style and priorities.' },
  { num: '02', title: 'Meet Your Wedding Expert', body: 'Speak with a Sunday Mirror wedding specialist.' },
  { num: '03', title: 'Build Your Wedding Plan', body: 'We recommend destinations, venues, budgets and the team required.' },
  { num: '04', title: 'Meet Your Team', body: 'Your dedicated Wedding Manager coordinates every workstream.' },
  { num: '05', title: 'Plan Everything Together', body: 'Track decisions, schedules, budgets, guests and suppliers through one process.' },
  { num: '06', title: 'Arrive & Celebrate', body: 'Our team moves into execution mode. You move into celebration mode.' },
];

export const MIRROR_AI_COUPLE = [
  'Explore destinations',
  'Estimate an initial wedding budget',
  'Build planning checklists',
  'Generate guest itineraries',
  'Compare venues',
  'Prepare questions for vendors',
  'Create mood-board directions',
  'Understand planning status and next steps',
];

export const MIRROR_AI_TEAM = [
  'Draft proposals',
  'Summarise meetings',
  'Compare vendors and scopes',
  'Build working timelines',
  'Support content creation',
  'Assist customer-support workflows',
];

export const REAL_WEDDINGS = [
  { couple: 'Ananya & Rohan', destination: 'Udaipur, Rajasthan', guests: 240, services: 'Full planning · Design · Hospitality', image: 'https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2', quote: 'Three ceremonies, two palaces, zero stress for us.' },
  { couple: 'Meera & Arjun', destination: 'Santorini, Greece', guests: 85, services: 'Destination · Planning · Films', image: 'https://images.unsplash.com/photo-1629942878547-cfd0c89b54d8', quote: 'They turned our vague Pinterest board into a real wedding.' },
  { couple: 'Kavya & Ishaan', destination: 'Kerala Backwaters', guests: 160, services: 'Design · Décor · Entertainment', image: 'https://images.unsplash.com/photo-1587271636175-90d58cdad458', quote: 'A wedding on a houseboat shouldn\'t be possible. It was.' },
  { couple: 'Zara & Dhruv', destination: 'Phuket, Thailand', guests: 120, services: 'Full planning · Guest hospitality', image: 'https://images.unsplash.com/photo-1669816834455-427acd3b1ca5', quote: 'Guests still tell us it felt like a one-week holiday.' },
  { couple: 'Priya & Vikram', destination: 'Lake Como, Italy', guests: 95, services: 'Destination · Planning · Photography', image: 'https://images.unsplash.com/photo-1731585926373-3bc511338cc0', quote: 'Every detail considered. Nothing left to chance.' },
  { couple: 'Sanya & Aarav', destination: 'Jaipur, Rajasthan', guests: 300, services: 'Full planning · Design · Films', image: 'https://images.unsplash.com/photo-1587271315307-eaebc181c749', quote: 'They made our palace wedding feel intimate.' },
];

export const TEAM = [
  { name: 'Anita Menon', role: 'Wedding Director', destinations: 'India · Italy · Greece', languages: 'EN · HI · ML', photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400' },
  { name: 'Rahul Nair', role: 'Destination Specialist', destinations: 'Thailand · Bali · Maldives', languages: 'EN · HI · ML', photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400' },
  { name: 'Priya Kapoor', role: 'Design Lead', destinations: 'Rajasthan · Kerala', languages: 'EN · HI · PA', photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400' },
  { name: 'Faisal Rahman', role: 'Guest Experience Manager', destinations: 'Dubai · Turkey · Mauritius', languages: 'EN · HI · AR', photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400' },
];

export const JOURNAL_POSTS = [
  { category: 'Destination Guides', title: 'Choosing between Udaipur and Jaipur for your winter wedding', excerpt: 'Two royal cities, two very different wedding experiences. Here is how to decide.', image: 'https://images.unsplash.com/photo-1661924326425-c14a6426d989?crop=entropy&cs=srgb&fm=jpg&q=85', read: '7 min' },
  { category: 'Planning Guides', title: 'The 18-month destination wedding timeline, demystified', excerpt: 'From save-the-dates to final RSVPs — the exact rhythm that avoids last-minute chaos.', image: 'https://images.unsplash.com/photo-1529636798458-92182e662485?crop=entropy&cs=srgb&fm=jpg&q=85', read: '9 min' },
  { category: 'Wedding Budgets', title: 'Where destination wedding budgets actually go', excerpt: 'A category-wise breakdown of a 150-guest destination wedding in India vs. abroad.', image: 'https://images.unsplash.com/photo-1561848355-890d054dc55a?crop=entropy&cs=srgb&fm=jpg&q=85', read: '6 min' },
  { category: 'Venue Guides', title: 'Twelve questions every couple should ask a destination venue', excerpt: 'The small-print questions that decide whether your wedding week runs smoothly.', image: 'https://images.unsplash.com/photo-1597682496035-b04f723202a4?crop=entropy&cs=srgb&fm=jpg&q=85', read: '8 min' },
];

export const TESTIMONIALS = [
  { quote: 'We didn\'t have to worry about a single thing. Our families actually danced.', couple: 'Ananya & Rohan', place: 'Udaipur' },
  { quote: 'A wedding abroad felt impossible until Sunday Mirror made it the easiest week of the year.', couple: 'Meera & Arjun', place: 'Santorini' },
  { quote: 'Vendors we would never have found on our own, briefed exactly the way we would have.', couple: 'Priya & Vikram', place: 'Lake Como' },
];

export const PRESS = ['Vogue India', 'Harpers Bazaar', 'Condé Nast Traveller', 'WeddingSutra', 'The Hindu', 'Architectural Digest'];
